<div class="flex flex-col h-screen w-full bg-gray-100 overflow-hidden font-sans">

  <!-- 🛠️ TOP HEADER: Fixed -->
  <header class="h-14 bg-[#006269] text-white flex items-center justify-between px-6 shadow-md shrink-0 z-5">
    <div class="flex items-center gap-3">
      <div class="bg-white/20 p-1.5 rounded-lg">
        <i class="fas fa-chart-line text-cyan-300"></i>
      </div>
      <div>
        <h1 class="font-bold text-sm lg:text-base tracking-wide uppercase leading-none">Purchase Bill Reports</h1>
        <!-- <p class="text-[9px] opacity-70 uppercase tracking-[0.2em] mt-1">Purchase Bill Reports</p> -->
      </div>
    </div>

    <!-- SEARCH BOX -->
    <div class="flex gap-2 items-center">

      <!-- Search -->
      <div class="relative w-64 lg:w-80">
        <i class="fas fa-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-xs"></i>
        <input type="text" [(ngModel)]="searchTerm" (input)="onSearch()" placeholder="Search..."
          class="w-full bg-white/10 border rounded-lg py-2 pl-10 pr-4 text-xs text-white">
      </div>

      <!-- Export ZIP -->
      <button (click)="exportZip()"
        class="h-9 px-4 rounded-lg bg-white text-[#006269] text-xs font-black uppercase flex items-center gap-2 hover:bg-cyan-50 transition">
        <i class="fas fa-file-archive"></i>
        Export ZIP
      </button>

    </div>
  </header>

  <!-- 📂 MAIN AREA: Now this area is the one that scrolls -->
  <main class="flex-1 overflow-y-auto p-4 lg:p-6 custom-scrollbar">
    <div class="max-w-10xl mx-auto space-y-4">

      <!-- SUMMARY CARDS -->
      <div class="grid grid-cols-1 md:grid-cols-3 gap-4 shrink-0">

        <!-- Total Amount -->
        <div class="bg-[#006269] rounded-2xl p-5 text-white shadow-lg">
          <p class="text-[10px] opacity-70 uppercase font-black tracking-widest mb-1">
            Total Purchase Amount
          </p>
          <h3 class="text-3xl font-black">₹ {{ totalGrandSum | number:'1.2-2' }}</h3>
        </div>

        <!-- Total Records -->
        <div class="bg-white rounded-2xl p-5 border shadow-sm">
          <p class="text-[10px] text-gray-400 uppercase font-black tracking-widest mb-1">
            Total Records
          </p>
          <h3 class="text-2xl font-black text-gray-800">{{ totalItems }}</h3>
        </div>

        <!-- Date Filter -->
        <div class="bg-white rounded-2xl p-4 border shadow-sm flex flex-col gap-2">
          <label class="text-[10px] uppercase font-black text-gray-400">Filter By Date</label>

          <div class="flex gap-2">
            <input type="date" [(ngModel)]="fromDate" (change)="applyFilter()"
              class="w-full text-xs border rounded-lg px-2 py-1" />

            <input type="date" [(ngModel)]="toDate" (change)="applyFilter()"
              class="w-full text-xs border rounded-lg px-2 py-1" />
          </div>
        </div>

      </div>


      <!-- DATA TABLE CONTAINER: Height now depends on content -->
      <div class="bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden">

        <!-- Loading Bar -->
        <div *ngIf="isLoading" class="h-1 bg-cyan-100 overflow-hidden">
          <div class="h-full bg-[#006269] animate-progress w-full"></div>
        </div>

        <div class="overflow-x-auto">
          <table class="w-full border-collapse text-left">
            <thead class="bg-gray-50 border-b border-gray-100 whitespace-nowrap">
              <tr>
                <th class="p-4 text-[10px] font-black text-gray-500 uppercase tracking-widest">Date</th>
                <th class="p-4 text-[10px] font-black text-gray-400 uppercase tracking-widest">Bill #</th>
                <th class="p-4 text-[10px] font-black text-gray-400 uppercase tracking-widest text-right">Amount</th>
                <th class="p-4 text-[10px] font-black text-gray-500 uppercase tracking-widest text-center">Document</th>
                <th class="p-4 text-[10px] font-black text-gray-500 uppercase tracking-widest text-center">Actions</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-50">
              <tr *ngFor="let bill of paginatedBills" class="hover:bg-blue-50/30 transition-colors group">
                <td class="p-4 whitespace-nowrap">
                  <div class="flex items-center gap-3">
                    <div class="h-8 w-8 rounded-lg bg-emerald-50 text-emerald-600 flex items-center justify-center">
                      <i class="fas fa-calendar-day text-xs"></i>
                    </div>
                    <span class="text-sm font-bold text-gray-700">{{ bill.bill_date | date:'dd MMM, yyyy' }}</span>
                  </div>
                </td>
                <td class="p-4 whitespace-nowrap">
                  <span class="text-xs font-mono text-gray-500 bg-gray-100 px-2 py-1 rounded">#{{ bill.id }}</span>
                </td>
                <td class="p-4 text-right whitespace-nowrap">
                  <span class="text-sm font-black text-[#006269]">₹ {{ bill.amount | number:'1.2-2' }}</span>
                </td>
                <td class="p-4 text-center whitespace-nowrap">
                  <button (click)="viewDocument(bill.document_url)"
                    class="text-[10px] font-black uppercase text-blue-600 hover:text-blue-800 bg-blue-50 px-3 py-1.5 rounded-full transition-all">
                    <i class="fas fa-file-pdf mr-1"></i> View Bill
                  </button>
                </td>
                <td class="p-4 text-center whitespace-nowrap">
                  <div class="flex justify-center gap-2">
                    <button (click)="deleteRecord(bill.id)"
                      class="h-8 w-8 rounded-lg text-gray-300 hover:text-red-600 hover:bg-red-50 transition-all">
                      <i class="fas fa-trash-alt text-xs"></i>
                    </button>
                  </div>
                </td>
              </tr>

              <!-- Empty State -->
              <tr *ngIf="paginatedBills.length === 0 && !isLoading">
                <td colspan="5" class="p-20 text-center">
                  <i class="fas fa-folder-open text-4xl text-gray-200 mb-4 block"></i>
                  <p class="text-gray-400 font-bold uppercase text-[10px] tracking-widest">No matching records found</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 🔢 PAGINATION FOOTER: Stays at bottom of the white card -->
        <footer class="h-14 border-t border-gray-100 bg-gray-50 flex items-center justify-between px-6 shrink-0">
          <p class="text-[10px] font-bold text-gray-400 uppercase tracking-widest">
            Showing {{ paginatedBills.length }} of {{ totalItems }} records
          </p>

          <div class="flex items-center gap-2">
            <button [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)"
              class="h-8 w-8 flex items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-500 hover:bg-[#006269] hover:text-white disabled:opacity-30 transition-all shadow-sm">
              <i class="fas fa-chevron-left text-[10px]"></i>
            </button>

            <span class="px-4 text-[10px] font-black text-[#006269] uppercase tracking-widest">
              Page {{ currentPage }} / {{ lastPage }}
            </span>

            <button [disabled]="currentPage >= lastPage" (click)="goToPage(currentPage + 1)"
              class="h-8 w-8 flex items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-500 hover:bg-[#006269] hover:text-white disabled:opacity-30 transition-all shadow-sm">
              <i class="fas fa-chevron-right text-[10px]"></i>
            </button>
          </div>
        </footer>

      </div>

      <!-- Extra padding at the bottom so footer isn't cramped -->
      <div class="h-10"></div>
    </div>
  </main>
</div>